const e = {
  name: "Rainbow",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M39,0C17.5,0,0,17.5,0,39v1h22v-1c0-9.4,7.6-17,17-17h1V0H39z M5,38H2C2.5,18.4,18.4,2.5,38,2v3
			C20,5.5,5.5,20,5,38z M7,38C7.5,21.1,21.1,7.5,38,7v3c-15.2,0.5-27.5,12.8-28,28H7z M38,12v3c-12.5,0.5-22.5,10.5-23,23h-3
			C12.5,23.9,23.9,12.5,38,12z M38,17v3c-9.7,0.5-17.5,8.3-18,18h-3C17.5,26.6,26.6,17.5,38,17z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Rainbow
};
